module.exports = __webpack_public_path__ + "img/arrow-down.5b2e35e9.svg";